import React from "react";

export const participantPayload = {
    'firstName': '',
    'lastName': '',
    'email': '',
    'address': '',
    'city': '',
    'region': '',
    'postalCode': '',
    'country': '',
    'phoneNumber':'',
    'mobileWalletServiceProviderId':0,
    'institutionId': '',
    'otherInstitutionName':'',
    'latitude': '',
    'longitude': '',
    'bankId': '',
    'bankCode' : '',
    'bankBranchCode' : '',
    'paymentMethod': 1,
    'mobileWalletNumber':'',
    'gender': '',
    'ghanaCardID': '',
    'designation': '',
    'bankAccountName': '',
    'bankAccountNumber': '',
    'bankAccountBranch': '',
    'dietryRestrictions':'None',
    'allegies': 'None',
    'otherConcerns': 'None',
    'accommodationRequired':false,
    'financialTermsAgreement': false,
    'photographTermsAgreement': false,
    'confirmationTermsAgreement': false,
    'value':null,
};